import { watch } from "vue";
import { useAuthenticationStore } from "@/store/authentication.store";
import { isHarnessFlagsSource } from "@/config/flags/flagsSource";
import { bootstrapHarnessFlags } from "@/config/split/harnessFlags";
import {
  createHarnessConfig,
  resolveTrafficKey,
} from "@/config/split/harnessConfig";
import { destroySplitClient, getSplitClient } from "@/config/split/splitClient";

/**
 * Initialises Harness flags for the current traffic key and re-keys when the
 * selected account changes.
 *
 * No-op unless the harness source is active, so the static system pays nothing.
 * Call once from the app root (App.vue setup) — after Pinia is active.
 */
export const useHarnessFlagsBootstrap = (): void => {
  if (!isHarnessFlagsSource()) return;

  const authStore = useAuthenticationStore();

  watch(
    () => resolveTrafficKey(authStore),
    async (key) => {
      if (getSplitClient()) await destroySplitClient();
      bootstrapHarnessFlags(createHarnessConfig(key));
    },
    { immediate: true },
  );
};
